import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Wrench } from "lucide-react";
import { api, saveToken, formatError } from "@/lib/api";
import { useSettings } from "@/lib/settings";
import BrandName from "@/components/BrandName";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const nav = useNavigate();
  const s = useSettings();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      saveToken(r.data.token);
      toast.success("Anmeldung erfolgreich");
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="flex min-h-screen items-center justify-center px-6 bg-grid"
    >
      <div className="w-full max-w-md border border-white/10 bg-[#0d0d10] p-10">
        <Link
          to="/"
          className="flex items-center gap-3"
        >
          {s.logo_url ? (
            <img
              src={s.logo_url}
              alt={s.workshop_name}
              className="h-10 max-w-[80px] object-contain"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : null}
          <BrandName
            name={s.workshop_name}
            size="sm"
            testId="admin-login-brand"
          />
        </Link>

        <div className="mt-10">
          <span className="tag-orange">Admin</span>
          <h1 className="mt-4 text-3xl font-black uppercase">Anmeldung</h1>
          <p className="mt-2 text-sm text-white/60">
            Nur für Werkstatt-Mitarbeiter.
          </p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <Label className="mono text-[11px] uppercase tracking-widest text-white/60">
              E-Mail
            </Label>
            <Input
              data-testid="login-email"
              type="email"
              className="mono mt-2 border-white/20 bg-black text-white"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <Label className="mono text-[11px] uppercase tracking-widest text-white/60">
              Passwort
            </Label>
            <Input
              data-testid="login-password"
              type="password"
              className="mono mt-2 border-white/20 bg-black text-white"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="mt-2 inline-flex w-full items-center justify-center gap-2 bg-[#FF4B00] px-6 py-3 text-xs font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#E64300] disabled:opacity-40"
          >
            <Lock className="h-4 w-4" strokeWidth={2.5} />
            {loading ? "Anmelden..." : "Anmelden"}
          </button>
        </form>

        <Link
          to="/admin/forgot-password"
          data-testid="forgot-link"
          className="mono mt-6 block text-center text-[10px] uppercase tracking-[0.2em] text-white/50 hover:text-[#FF4B00]"
        >
          Passwort vergessen?
        </Link>
      </div>
    </div>
  );
}
